
export const BLANK_TEMPLATE = 'BLANK_TEMPLATE';
export const BLANK_TEMPLATE_ICON = 'add';
